<div class="row">
    <div class="col-lg-12">
        <div class="card card-outline-success">
            <div class="card-header">
                <div style="float: left; position: relative; width: 70%; border-collapse: collapse; text-align: left">
                    <h4 class="m-b-0 text-white">Material</h4>
                </div>
            </div>
            <div class="card-body" id="padre">
                <h3>Lista de materiales que solicitan apoyo</h3>
                <!-- ============================ -->
                <!-- Tabla materiales solicitados -->
                <!-- ============================ -->
                <div class="materiales">
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Cantidad en almacen físico</th>
                                <th>Cantidad Solicitada</th>
                                <th>Apoyo</th>
                                <th>Sucursal</th>
                                <th>Agregar</th>
                                <th>Negar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let producto of materialesObtenidos" style="text-align: center">
                                <td>{{ producto.codigo }}</td>
                                <td>{{ producto.descripcion }}</td>
                                <td>{{ producto.almacenFisico }}</td>
                                <td>{{ producto.cantidad }}</td>
                                <td>
                                    <!-- Propiedad disabled utilizada para bloquear el imput, sólo agregar cantidad cuando vuelvan a solicitar el apoyo -->
                                    <input class="form-control" [disabled]="producto.cantidadApoyoSucursal" [(ngModel)]="producto.cantidadApoyoSucursal">
                                </td>
                                <td>{{ producto.sucursal }}</td>
                                <td>
                                    <button class="btn btn-success" [disabled]="producto.cantidadApoyoSucursal" (click)="agregarMaterial(producto)">Agregar</button>
                                </td>
                                <td style="text-align: center">
                                    <button class="btn btn-outline-light" (click)="negarApoyo(producto)" [disabled]="producto.cantidadApoyoSucursal">
                                        <i class="fa fa-close text-danger" ></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- ============================ -->
                <!-- Tabla materiales solicitados -->
                <!-- ============================ -->
                <!-- ============================ -->
                <!-- Tabla materiales solicitados -->
                <!-- ============================ -->
                <div id="materialesEnviar" style="display: none">
                    <br>
                    <br>
                    <h3>Materiales a enviar</h3>
                    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger2" class="display nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
                        <thead>
                            <tr style="text-align: center">
                                <th>Codigo</th>
                                <th>Descripcion</th>
                                <th>Cantidad Solicitada</th>
                                <th>Eliminar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let solicitud of arrayMaterialSolicitado" style="text-align: center">
                                <td>{{ solicitud.codigo }}</td>
                                <td>{{ solicitud.descripcion }}</td>
                                <td>{{ solicitud.cantidadApoyo }}</td>
                                <td (click)="eliminarMaterial(solicitud)">
                                    <a style="text-align: center">
                                        <i class="fa fa-close text-danger"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- ============================ -->
                <!-- Tabla materiales solicitados -->
                <!-- ============================ -->
                <br>
                <button class="btn btn-danger float float-right" id="btnResponderSolicitud" style="display: none" (click)="enviarRespuesta()">Responder solicitud</button>
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// C:/xampp/htdocs/sm8-v1-front/src/app/_components/operaciones/material-pendiente-apoyo/material-pendiente-apoyo.component.html